export function numberToIndianWords(num) {
  const a = [
    "",
    "One",
    "Two",
    "Three",
    "Four",
    "Five",
    "Six",
    "Seven",
    "Eight",
    "Nine",
    "Ten",
    "Eleven",
    "Twelve",
    "Thirteen",
    "Fourteen",
    "Fifteen",
    "Sixteen",
    "Seventeen",
    "Eighteen",
    "Nineteen",
  ];
  const b = [
    "",
    "",
    "Twenty",
    "Thirty",
    "Forty",
    "Fifty",
    "Sixty",
    "Seventy",
    "Eighty",
    "Ninety",
  ];

  const makeWords = (n) => {
    if (n < 20) return a[n];
    if (n < 100) return b[Math.floor(n / 10)] + (n % 10 ? " " + a[n % 10] : "");
    return "";
  };

  if (num === 0) return "Zero Rupees Only";

  const numStr = ("000000000" + num).substr(-9);
  const crore = parseInt(numStr.substr(0, 2));
  const lakh = parseInt(numStr.substr(2, 2));
  const thousand = parseInt(numStr.substr(4, 2));
  const hundred = parseInt(numStr.substr(6, 1));
  const rest = parseInt(numStr.substr(7, 2));

  let str = "";

  if (crore) str += makeWords(crore) + " Crore ";
  if (lakh) str += makeWords(lakh) + " Lakh ";
  if (thousand) str += makeWords(thousand) + " Thousand ";
  if (hundred) str += a[hundred] + " Hundred ";
  if (rest) str += (str ? "and " : "") + makeWords(rest) + " ";

  return str.trim() + " Rupees Only";
}
